import { FC, useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'application/providers/RouterProvider';
import { useGetNotifications, useSetNotificationViewed } from '@entities/media';
import { useAccountCompanyId, useAccountIsReadyToUseLK } from 'application/hooks';
import { REPORTS_PAGE_PATH } from 'application/pages/ReportsPage';
import { ViewNotificationMutationInput } from '@shared/api/graphql/generated';
import GeneratedReportsModal from './index';

enum NOTIFICATION_TYPES {
  RAO_VOIS_COMPANY_REPORT_CREATED = 'rao_vois_company_report_created',
}

const NOTIFICATION_TYPE_ROUTES: { [key: string]: string } = {
  [NOTIFICATION_TYPES.RAO_VOIS_COMPANY_REPORT_CREATED]: REPORTS_PAGE_PATH,
};

const GeneratedReportsViewport: FC = () => {
  const navigate = useNavigate();
  const notifications = useGetNotifications();
  const { request: setNotificationViewed } = useSetNotificationViewed();
  const [showModal, setShowModal] = useState(false);
  const companyId = useAccountCompanyId();
  const isReadyToUseLK = useAccountIsReadyToUseLK();
  const result = notifications?.data?.result;
  const isNotificationShow = showModal && result && result.length;

  useEffect(() => {
    if (companyId && isReadyToUseLK) {
      notifications?.refetch();
    }
  }, [companyId, isReadyToUseLK]);

  useLayoutEffect(() => {
    if (result) {
      setShowModal(true);
    }
  }, [result]);

  if (!isNotificationShow) {
    return null;
  }

  const [firstNotification] = result;
  const notificationId = firstNotification.modelId;

  const handleNotificationViewed = (input: ViewNotificationMutationInput) => {
    setShowModal(false);
    setNotificationViewed(input);
  };

  const confirmHandler = (input: ViewNotificationMutationInput) => {
    const navigationPage = NOTIFICATION_TYPE_ROUTES[firstNotification.notificationType];

    if (navigationPage) {
      navigate(navigationPage);
    }

    handleNotificationViewed(input);
  };

  return (
    <GeneratedReportsModal
      title={firstNotification.title}
      message={firstNotification.message}
      buttonText={firstNotification.confirm}
      isCloseDisabled={firstNotification.isBlocked}
      notificationType={firstNotification.notificationType}
      onCancel={() => handleNotificationViewed({ notificationId })}
      onConfirm={() => confirmHandler({ notificationId })}
    />
  );
};

export default GeneratedReportsViewport;
